// extracted by mini-css-extract-plugin
export default {"group":"bCvci","title":"m67QF","size":"fcV8w"};